import { BRAND } from "../data/content";

export default function Marquee() {
  const items = ["ART\u2019S TRUE FORM", "MUSIC", "VISUALS", "CULTURE", "EXPERIENCE"];
  const line = [...items, ...items, ...items];
  return (
    <div className="relative py-8 md:py-12 border-y border-white/10 overflow-hidden bg-[color:var(--graphite)]" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((rep) => (
          <div key={rep} className="flex items-center">
            {line.map((t, i) => (
              <span key={`${rep}-${i}`} className="flex items-center">
                <span className="font-display steel-text text-3xl md:text-5xl px-6 md:px-10 italic">{t}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-white/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
      <span className="sr-only">{BRAND.phrase}</span>
    </div>
  );
}
